module.exports = __webpack_public_path__ + "static/media/BAKE.0e967dc8.svg";